import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ZapIcon } from 'lucide-react';
export function MechanismSection() {
  return <AnimatedSection className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-227">
      <div className="text-center mb-8" data-id="element-228">
        <span className="inline-flex items-center gap-2 py-1.5 px-4 rounded-full bg-sage/10 text-sage text-sm font-medium mb-6 border border-sage/20" data-id="element-229">
          <ZapIcon className="w-4 h-4" data-id="element-230" />
          El Mecanismo Único
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-231">
          El Método Cero Cortisol
        </h2>
      </div>

      <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-charcoal/5" data-id="element-232">
        <div className="space-y-6 text-lg text-charcoal/80 leading-relaxed" data-id="element-233">
          <p data-id="element-234">
            La solución no está en tu mente, está en tu{' '}
            <span className="text-sage font-bold" data-id="element-235">Nervio Vago</span>.
          </p>
          <p data-id="element-236">
            Este es el <span className="italic" data-id="element-237">"freno de mano" biológico</span>{' '}
            de tu cuerpo.
          </p>
          <p data-id="element-238">
            Este protocolo utiliza técnicas físicas de precisión —
            <span className="text-terracotta font-semibold" data-id="element-239">
              térmicas, respiratorias y de presión
            </span>
            — que obligan a tu sistema nervioso a pasar de "supervivencia" a
            "calma" en menos de 2 minutos.
          </p>
          <div className="bg-sage/10 rounded-xl p-6 border border-sage/20 mt-8" data-id="element-240">
            <p className="text-charcoal font-semibold text-center text-xl" data-id="element-241">
              No necesitas creer en ello; es pura{' '}
              <span className="text-sage" data-id="element-242">neurobiología aplicada</span>.
            </p>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}